import request from '../baseUtils/request'
//新手引导 -  获取用户引导列表
export function getBeginnerGuidanceShowList() {
	return request({
		method: 'post',
		url: '/beginnerGuidance/getBeginnerGuidanceShowList',
		
	})
}
//新手引导 - 删除新手引导用户记录
export function addUserRecord(data) {
	return request({
		method: 'POST',
		url: `/beginnerGuidance/addUserRecord`,
		data
	})
}

// 更新气泡获取列表
export function getFeatureRemindList() {
	return request({
		method: 'POST',
		url: `/featureRemind/window/getFeatureRemindList`,
		
	})
}

// 更新气泡-添加气泡记录
export function addBubbleRecord(data) {
	return request({
		method: 'POST',
		url: `/featureRemind/window/addUserRecord`,
		data
	})
}